import { CardGroup as _CardGroup, CardGroupProps as _CardGroupProps } from "reactstrap";

    export const CardGroup = _CardGroup;
    export type CardGroupProps = _CardGroupProps;
    